import { RootState } from "../store";
import { accountFeatures } from "../util";

export const selectActiveUserAccount = (state: RootState) => state.activeUser.account;

export const selectIsPro = (state: RootState) => {
  const account = selectActiveUserAccount(state);
  return accountFeatures(account).pro;
};
